<template>
  <div>
    <!--begin::Advance Table Widget 10-->
    <div class="card card-custom gutter-b">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">收支明细</span>
          <span class="text-muted mt-3 font-weight-bold font-size-sm"
            >仅显示最近30条记录</span
          >
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_4"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="min-width: 120px">交易时间</th>
                <th style="min-width: 110px">交易类型</th>
                <th style="min-width: 110px">交易渠道</th>
                <th style="min-width: 110px">入账（元）</th>
                <th style="min-width: 110px">支出（元）</th>
                <th style="min-width: 110px">可用余额（元）</th>
                <th style="min-width: 120px">相关描述</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in fetchExpendComputed()">
                <tr v-bind:key="i">
                  <!--                <td class="pl-0 py-6">-->
                  <!--                  <label class="checkbox checkbox-lg checkbox-single">-->
                  <!--                    <input type="checkbox" :value="i" :checked="checked" />-->
                  <!--                    <span></span>-->
                  <!--                  </label>-->
                  <!--                </td>-->
                  <td class="pl-0">
                    <span class="text-dark-65 font-size-lg">
                      {{
                        item.trading_hours | parseTime("{y}-{m}-{d} {h}:{i}")
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.trading_type }}</span
                    >
                  </td>
                  <td>
                    <span
                      v-if="item.trading_channel === 'balance'"
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >余额</span
                    >
                    <span
                      v-if="item.trading_channel === 'weixin'"
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >微信支付</span
                    >
                    <span
                      v-if="item.trading_channel === 'alipay'"
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >支付宝</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-primary font-weight-bolder d-block font-size-lg"
                      >{{ item.entry / 100 }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.expend / 100 }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.balance / 100 }}</span
                    >
                  </td>
                  <td>
                    <span class="text-muted font-weight-bold">{{
                      item.memo
                    }}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 10-->
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="10"
      aria-controls="my-table"
      class="mt-3 text-right float-right"
    ></b-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getInstance } from "@/api/instance";
export default {
  name: "widget-2",
  computed: {
    ...mapGetters(["currentUserBalance"]),
    fetchExpendComputed() {
      return function () {
        return this.list;
      };
    },
  },
  data() {
    return {
      checked: false,
      list: [],
      pagination: {
        total: "",
      },
      currentPage: 1,
    };
  },
  components: {},
  watch: {
    currentPage: {
      handler: function () {
        getInstance("EXPEND", {
          ctime$sort: "DESC",
          $limit: 10,
          $start: this.currentPage * 10 - 10,
        }).then((res) => {
          this.list = res.result;
          this.pagination.total = res.total;
        });
      },
      deep: true,
    },
  },
  created() {
    this.fetchExpend();
  },
  methods: {
    setCheck(check) {
      if (check) {
        this.checked = check;
      } else {
        this.checked = false;
      }
    },
    fetchExpend() {
      getInstance("EXPEND", { ctime$sort: "DESC", $limit: 10 }).then((res) => {
        this.list = res.result;
        this.pagination.total = res.total;
      });
    },
  },
};
</script>
